// Boat Content
import BoatHero from 'assets/images/psp/hero/boat-hero.webp';
import Outdoor from 'assets/images/icons/psp/outdoor.svg';
import DryStack from 'assets/images/icons/psp/dry-stack.svg';
import Indoor from 'assets/images/icons/psp/indoor.svg';
import tenByFifteen from 'assets/images/icons/boat-storage/10x15--boat-space.svg';
import tenByTwenty from 'assets/images/icons/boat-storage/10x20--boat-space.svg';
import tenByTwentyFive from 'assets/images/icons/boat-storage/10x25--parking-space.svg';
import tenByThirty from 'assets/images/icons/boat-storage/10x30--boat-space.svg';
import tenByThirtyFive from 'assets/images/icons/boat-storage/10x35--boat-space.svg';
import tenByForty from 'assets/images/icons/boat-storage/10x40--boat-space.svg';
import tenByFifty from 'assets/images/icons/boat-storage/10x50--boat-space.svg';
import Featured1 from 'assets/images/psp/FeaturedImages/kayakFeatured2.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/kayakFeatured3.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/boatFeatured3.webp';

const boatStorageTips = [
	'Learning how to prepare your boat for storage is one of the most important things a responsible boat owner can do. By taking a few simple steps, you can prepare your boat for storage and ensure smooth sailing the next time you take it out. These steps also cover a majority of what you’ll learn on your journey to discovering [how to prepare your boat for winter storage](https://sparefoot.com/blog/how-to-winterize-a-boat).',
];

const reviews = [
	{
		reviewTitle: 'Representative was professional',
		reviewRating: 5,
		reviewText:
			'The representative was professional and helpful in finding me a boat storage facility. Her knowledge of what I need was extraordinary. Thank you.',
		reviewerInitials: 'JG',
		link: 'https://www.trustpilot.com/reviews/64e1587d8939eed74a3bfa88',
		reviewerName: 'Jorge Gonzalez',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Helpful!!',
		reviewRating: 5,
		reviewText:
			'I was looking for outdoor storage for my boat, and they narrowed down a great spot I could reserve close to my residence in minutes. Very polite to deal with.',
		reviewerInitials: 'KW',
		link: 'https://www.trustpilot.com/reviews/63b715504d0773066a2f17b4',
		reviewerName: 'Kevin H. Whittemore',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'I was between a rock and a hard place. SpareFoot helped.',
		reviewRating: 5,
		reviewText:
			"I was between a rock and a hard place. The space I had set up wasn't wide enough for my boat. I called SpareFoot and they found me a place and reserved it within a couple minutes of where I was. The space worked perfectly.",
		reviewerInitials: 'AS',
		link: 'https://www.trustpilot.com/reviews/6239e9d9ab0a5e0f748026d6',
		reviewerName: 'Aaron E. Smith',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Found best deal on storage for my boat',
		reviewRating: 5,
		reviewText:
			'Found best deal on storage for my boat and moved in same day. Excellent, efficient service. Thank you!',
		reviewerInitials: 'SK',
		link: 'https://www.trustpilot.com/reviews/5ec709ae25e5d20a889c2b95',
		reviewerName: 'Stephen J Krug',
		reviewDate: 'January 3rd, 2023',
	},
];
const faqs = [
	{
		question: 'How much does it cost to store a boat?',
		answer:
			"Boat storage costs vary significantly based on location, storage type, and boat size. Here's what you can expect to pay:\n\n" +
			'**Indoor Storage:**\n\n' +
			'- Small boats (under 20 feet): $50-$200 per month\n' +
			'- Medium boats (20-30 feet): $150-$400 per month\n' +
			'- Large boats (30+ feet): $300-$800+ per month\n\n' +
			'**Outdoor Storage:**\n\n' +
			'- Uncovered outdoor storage: $20-$100 per month\n' +
			'- Covered outdoor storage: $50-$200 per month\n\n' +
			'**Dry Stack Storage (marina-operated):**\n\n' +
			'- $100-$500 per month, depending on boat size and location\n\n' +
			'**Factors affecting cost:**\n\n' +
			'- Geographic location (coastal areas typically cost more)\n' +
			'- Seasonal demand (higher rates during peak boating season)\n' +
			'- Security features and facility amenities\n' +
			'- Length of storage commitment (annual contracts often offer discounts)',
	},
	{
		question: 'Can you store a boat in a storage unit?',
		answer:
			'Yes, you can store [a boat in a storage unit](https://sparefoot.com/blog/storing-a-boat), but there are important considerations:\n\n' +
			'**Size Requirements:**\n\n' +
			"- Measure your boat's length, width, and height, including the trailer\n" +
			'- Account for any protruding parts like motors or bow rails\n' +
			'- Consider door height and width for entry\n\n' +
			'**Unit Types:**\n\n' +
			'- Drive-up units work best for easy access\n' +
			'- Climate-controlled units help protect against temperature extremes\n' +
			'- Ensure adequate ceiling height for your boat and trailer\n\n' +
			'**Preparation Steps:**\n\n' +
			'- Clean and dry the boat thoroughly before storage\n' +
			'- Remove all water to prevent freezing damage\n' +
			'- Consider partially deflating inflatable boats to save space\n\n' +
			'**Facility Policies:**\n\n' +
			'- Check storage facility rules about boat storage\n' +
			'- Verify insurance coverage for watercraft\n' +
			'- Some facilities may require proof of registration',
	},
	{
		question: 'How to keep mice out of boats during winter storage?',
		answer:
			'[Preventing mice infestation during winter storage](https://sparefoot.com/blog/how-to-pest-proof-your-storage-unit) requires a multi-step approach:\n\n' +
			'**Preparation and Cleaning:**\n\n' +
			'- Remove all food, beverages, and scented items from the boat\n' +
			'- Vacuum thoroughly, including cushions, storage compartments, and crevices\n' +
			'- Clean up any crumbs or food residue\n\n' +
			'**Physical Barriers:**\n\n' +
			'- Seal all openings with steel wool or copper mesh\n' +
			'- Cover air vents with fine mesh screens\n' +
			'- Close and secure all hatches, compartments, and storage areas\n' +
			'- Use expanding foam to fill larger gaps (removable type)\n\n' +
			'**Natural Deterrents:**\n\n' +
			'- Place cotton balls soaked in peppermint oil throughout the boat\n' +
			'- Use dryer sheets in storage compartments and engine areas\n' +
			'- Scatter Irish Spring soap shavings around the boat\n\n' +
			'**Professional Solutions:**\n\n' +
			'- Set snap traps in strategic locations (check facility policies first)\n' +
			'- Use ultrasonic pest repellents designed for enclosed spaces\n' +
			'- Consider professional pest control treatment before storage\n\n' +
			'**Regular Monitoring:**\n\n' +
			'- Check on your boat periodically during storage season\n' +
			'- Look for signs of rodent activity, like droppings or chewed materials\n' +
			'- Refresh deterrents as needed',
	},
	{
		question:
			'Should I disconnect my boat battery during long-term boat storage?',
		answer:
			"Yes, you should disconnect your boat battery during long-term storage. Here's the complete approach:\n\n" +
			'**Why Disconnect:**\n\n' +
			'- Prevents parasitic drain from electronics and systems\n' +
			'- Reduces the risk of battery corrosion and damage\n' +
			'- Eliminates potential fire hazard from electrical issues\n' +
			'- Extends battery life significantly\n\n' +
			'**Proper Disconnection Process:**\n\n' +
			'- Turn off all electrical systems and accessories\n' +
			'- Disconnect the negative (-) terminal first\n' +
			'- Then disconnect the positive (+) terminal\n' +
			'- Clean terminals with a baking soda solution if corroded\n' +
			'- Apply terminal protector spray or petroleum jelly\n\n' +
			'**Battery Storage Options:**\n\n' +
			'- Remove the battery completely and store it in a cool, dry place\n' +
			"- If you’re leaving it in the boat, then ensure it's in a well-ventilated area\n" +
			'- Store in a location where the temperature stays above freezing\n\n' +
			'**Maintenance During Storage:**\n\n' +
			'- Check battery charge monthly\n' +
			'- Recharge if the voltage drops below 12.4 volts\n' +
			'- Consider using a battery tender/maintainer for automatic charging\n' +
			'- Inspect for signs of damage or leakage regularly',
	},
	{
		question: 'Should I store my boat with a full tank of gas?',
		answer:
			'Yes, you should store your boat with a full tank of gas, but with proper preparation:\n\n' +
			'**Why Fill the Tank:**\n\n' +
			'- Prevents condensation from forming in empty space\n' +
			'- Reduces air exposure that can cause fuel degradation\n' +
			'- Minimizes the risk of water contamination\n' +
			'- Prevents fuel system components from drying out\n\n' +
			'**Essential Fuel Preparation Steps:**\n\n' +
			"- Add marine fuel stabilizer before filling (follow manufacturer's ratios)\n" +
			'- Fill the tank completely to minimize air space\n' +
			'- Run the engine for 10-15 minutes after adding stabilizer to circulate the treated fuel\n' +
			'- Top off the tank after engine run to account for fuel consumed\n\n' +
			'**Fuel Stabilizer Benefits:**\n\n' +
			'- Prevents fuel oxidation and gum formation\n' +
			'- Protects fuel system components\n' +
			'- Maintains fuel quality for 12-24 months\n' +
			'- Reduces potential starting problems in spring\n\n' +
			'**Additional Considerations:**\n\n' +
			'- Use ethanol-free fuel if available for long-term storage\n' +
			'- Consider adding fuel system cleaner before storage\n' +
			'- If storing longer than one season, consider draining and refilling with fresh fuel\n' +
			'- Check local regulations about fuel storage in storage facilities\n\n' +
			'**Engine Preparation:**\n\n' +
			'- Change the engine oil before storage\n' +
			'- Fog the engine cylinders if recommended by the manufacturer\n' +
			"- Replace the fuel filter if it hasn't been changed recently",
	},
];

export const BoatContent = {
	type: 'Boat',
	sections: [
		{
			title: 'RV Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'rv-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Boat Storage For You',
							description:
								"You love your boat, and you want your boat to love you back. The best way to ensure your boat keeps treating you to beautiful memories on the lake or out at sea is to take care of it even when you're not at the helm. Boats require proper storage away from the sun, extreme weather, and the threat of theft. We can help you find boat and trailer storage near you that fits your needs and budget. From dry stack storage to a climate-controlled storage unit fit for your vessel, SpareFoot makes it easier than ever to find boat storage near you.",
							image: BoatHero,
							CTAText: 'Search Boat Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Boat Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Boat-Storage Size Comparison',
			modules: [
				{
					title: 'Boat Storage Content',
					type: 'content',
					props: {
						title: 'What Kind of Boat Storage Do You Need? ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Self-storage facilities that provide boat and trailer storage services offer three types of boat storage: outdoor boat storage, stack or dry stack storage, and indoor boat storage. These storage services are each designed to protect your boat or trailer, but come with different perks and price points. The winner of the age-old indoor vs outdoor boat storage debate largely depends on the size of your vessel, your location, and what you're willing to spend to keep Sailin' Sally safe.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'boat-storage-size-chart',
						headers: [
							{
								label: 'Boat and Trailer Storage Type',
								key: 'Boat and Trailer Storage Type',
							},
							{
								label: 'What is it?',
								key: 'What is it?',
							},
							{
								label: 'Benefits',
								key: 'Benefits',
							},
							{
								label: 'Cost Comparison',
								key: 'Cost Comparison',
							},
						],
						rows: [
							{
								'Boat and Trailer Storage Type': {
									type: 'icon',
									icon: Outdoor,
									heading: 'Outdoor Boat Storage',
								},
								'What is it?':
									"Large parking spaces where boats and trailers can be stored. Some facilities offer covered outdoor boat storage, but you'll need to read individual listings if a covered boat space is what you're looking for. ",
								Benefits:
									'Ideal for those living in and storing boats in mild climates, outdoor boat storage frees up space on your personal property and provides a safe place to store and park your boat. This storage option is best paired with a boat cover.',
								'Cost Comparison':
									'Cheapest boat storage option.',
							},
							{
								'Boat and Trailer Storage Type': {
									type: 'icon',
									icon: Indoor,
									heading: 'Indoor Boat Storage',
								},
								'What is it?':
									"Indoor storage units are a good option for boats less than 50 feet long, as you'll want to ensure your indoor boat storage unit has ample space to move around and maneuver the boat while it is in storage. Another indoor boat and trailer storage option is warehouse-style storage, where your boat will be stored with other watercraft.",
								Benefits:
									"Keeping your watercraft indoors will give you the option of finding a facility that offers heated boat storage, perfect for areas that experience freezing temperatures. You'll also enjoy additional perks like added security, boat winterization, trailer storage, and boat transport, depending on your facility and storage package. ",
								'Cost Comparison':
									'Depending on your decision to store your boat in a storage unit or a warehouse, this option is for those with a medium to high budget. The added perks and amenities offered by indoor storage units create some variability in prices, which are balanced by added convenience and amenities. ',
							},
							{
								'Boat and Trailer Storage Type': {
									heading: 'Stack/Dry Stack Boat Storage',
									type: 'icon',
									icon: DryStack,
								},
								'What is it?':
									'Stack or dry stack boat storage is an affordable alternative to creeping marina fees. Your boat will be stacked on a large rack with other boats. Dry stack storage takes the same approach, but will store each stack in a warehouse protected from the elements 24/7-365. Always measure your boat before choosing dry stack boat storage, as there are some size limitations.',
								Benefits:
									'Dry stack storage, in particular, offers year-round protection from sun, rain, snow, and other extreme weather. ',
								'Cost Comparison':
									"This is another mid-budget option, with pricing variations based on location, seasonality, and whether you're opting for dry stack over standard stack storage.",
							},
						],
					},
				},
			],
		},
		{
			title: 'Boat-Storage Size Comparison',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					title: 'Boat Storage Content',
					type: 'content',
					props: {
						title: 'What Size Storage Unit Do You Need for Your Boat? ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Boat storage applies to any watercraft, from pontoon storage to [jet-ski storage](/jet-ski-storage.html), and everything in between. But boats come in different shapes and sizes, and require different things, like additional boating trailer storage. Finding the right marine storage solution for you means figuring out just how much space you need to securely store your boat.',
							"Check out our helpful boat storage size guide below for help picking out your boat's new haven. Then head over to our [storage unit size guide](https://www.sparefoot.com/storage-unit-size-guide.html) to learn more about storage unit dimensions and how to store oversized or awkwardly shaped items like kayaks.",
						],
					},
				},
				{
					type: 'unitList',
					id: 'boat-storage-size-guide',
					props: {
						slug: 'boat-storage-size-guide',
						unitsData: [
							{
								title: '10’ Wide x 15’ Long',
								infoTag: '150 SQ FT',
								image: tenByFifteen,
								content:
									'- Most small single-person fishing or rowing boats, plus personal water crafts, come in at just around 15 feet in length.\n\n' +
									'- Always make sure to measure your boat before renting out a storage unit, it must be under 15 feet in length to fit in a 10’x15’ unit.\n\n' +
									'-Because most small boats fit into a 10’ wide unit, most boat storage facilities will not note the width on their facility page.\n\n',
							},
							{
								title: '10’ Wide x 20’ Long',
								infoTag: '200 SQ FT',
								image: tenByTwenty,
								content:
									'- Personal watercraft (jet skis, wave runners) - typically 10-12 feet long\n\n' +
									'- Small fishing boats and dinghies (12-16 feet)\n\n' +
									'- Kayaks and canoes (multiple units)\n\n' +
									'- Small sailboat dinghies (8-14 feet)\n\n' +
									'- Jon boats and car-top boats\n\n' +
									'- Most boats in this category will be stored on small trailers, adding 2-4 feet to overall length\n\n',
							},
							{
								title: '10’ Wide x 25’ Long',
								infoTag: '250 SQ FT',
								image: tenByTwentyFive,
								content:
									'- Small to mid-size fishing boats (16-20 feet)\n\n' +
									'- Runabouts and bowriders (16-20 feet)\n\n' +
									'- Bass boats (17-20 feet)\n\n' +
									'- Small pontoon boats (16-20 feet)\n\n' +
									'- Small center console boats (17-19 feet)\n\n' +
									'- Day sailers and small cabin sailboats (up to 20 feet)\n\n' +
									"- Remember that boats on trailers typically add 3-5 feet to the boat's stated length\n\n",
							},
							{
								title: '10’ Wide x 30’ Long',
								infoTag: '300 SQ FT',
								image: tenByThirty,
								content:
									'Mid-size boats (20-24 feet) including pontoons, fishing boats, and cruisers' +
									'- Walleye and musky fishing boats (20-24 feet)\n\n' +
									'- Deck boats and sport boats (20-24 feet)\n\n' +
									'- Wakeboard and ski boats (20-23 feet)\n\n' +
									'- Small cabin cruisers (22-24 feet)\n\n' +
									'- Boats with towers, bimini tops, or T-tops may require 12-14 foot ceiling heights\n\n' +
									'- Always account for the trailer tongue extending beyond the bow\n\n',
							},
							{
								title: '10’ Wide x 35’ Long',
								infoTag: '350 SQ FT',
								image: tenByThirtyFive,
								content:
									'- Larger boats (24-28 feet) suitable for coastal and offshore use \n\n' +
									'- Express cruisers and cuddy cabins (24-28 feet)\n\n' +
									'- Larger center console boats (24-27 feet)\n\n' +
									'- Large pontoon boats (24-28 feet)\n\n' +
									'- Walkarounds and pilothouse boats (24-27 feet)\n\n' +
									'- Small sailboats with keels (up to 26 feet)\n\n' +
									'- Boats with hardtops, radar arches, or tall outboards may need 14-16 foot ceilings\n\n',
							},
							{
								title: '10’ Wide x 40’ Long',
								infoTag: '400 SQ FT',
								image: tenByForty,
								content:
									'Large boats (28-32 feet) including offshore fishing boats and cruisers' +
									'- Sport fishing boats with towers (28-32 feet)\n\n' +
									'- Large express cruisers and sedan cruisers (28-32 feet)\n\n' +
									'- Large center consoles with T-tops (28-31 feet)\n\n' +
									'- Downeast-style boats (28-32 feet)\n\n' +
									'- Catamarans (up to 30 feet)\n\n' +
									'- Many boats this size have significant beam (width of 9-11 feet) and may require wider door openings\n\n' +
									'- Tower-equipped boats often require 16-18 foot ceiling clearance\n\n',
							},
							{
								title: '10’ Wide x 50’ Long',
								infoTag: '500 SQ FT',
								image: tenByFifty,
								content:
									'Very large boats (32-40+ feet) including offshore sportfishers and yachts' +
									'- Large sportfishing boats with towers (32-40 feet)\n\n' +
									'- Motor yachts and trawlers (32-38 feet)\n\n' +
									'- Large cruisers and flybridge boats (32-40 feet)\n\n' +
									'- Large sailboats (30-38 feet) - may require mast removal\n\n' +
									'- These vessels often exceed 10 feet in beam and may require 12-14 foot wide units\n\n' +
									'- Tower-equipped boats routinely need 18-20+ foot ceiling clearance\n\n',
							},
						],
					},
				},
			],
		},
		{
			title: 'Why You Should Store Your Boat at a Storage Facility',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						content: {
							title: 'Why Choose a Boat Storage Facility Over Boat Parking at Home? ',
							description:
								"[Boat and RV storage](https://sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat) searchers face a similar predicament: if you park your fun machine at home, it's convenient and close by, sure, but your neighbors are mad, your partner is annoyed, and your driveway is full. This is why, of all the boat storage ideas out there, finding a boat storage facility is at the top of the list. Need another reason to outsource your boat storage? Look no further:",
						},
						src: 'https://www.youtube.com/embed/GL1C2GX9BYQ',
					},
				},
			],
		},
		{
			title: 'Boat-Storage Size Comparison',
			modules: [
				{
					title: 'Boat Storage Content',
					type: 'content',
					props: {
						title: 'How Much Does It Cost to Store a Boat? ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Boat storage prices vary greatly based on seasonal demand, indoor vs outdoor boat storage, and additional amenities like climate controlled boat storage. The good news is that boat storage costs are often billed monthly, making boat storage rentals flexible for short-term and long-term stays. ' +
								"Below, you'll find average boat storage rates across different unit sizes.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'boat-storage-size-chart',
						headers: [
							{
								label: 'Storage Unit Size',
								key: 'Storage Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
						],
						rows: [
							{
								'Storage Unit Size': '10x15',
								'Average Monthly Price': '$80.65',
							},
							{
								'Storage Unit Size': '10x20',
								'Average Monthly Price': '$77.19',
							},
							{
								'Storage Unit Size': '10x30',
								'Average Monthly Price': '$84.99',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: ['\n\n'],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'boat-storage-size-chart',
						headers: [
							{
								label: 'Parking Unit Size',
								key: 'Parking Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
						],
						rows: [
							{
								'Parking Unit Size': "15' Long",
								'Average Monthly Price': '$79.56',
							},
							{
								'Parking Unit Size': "20' Long",
								'Average Monthly Price': '$77.17',
							},
							{
								'Parking Unit Size': "25' Long",
								'Average Monthly Price': '$80.04',
							},
							{
								'Parking Unit Size': "30' Long",
								'Average Monthly Price': '$85.01',
							},
							{
								'Parking Unit Size': "35' Long",
								'Average Monthly Price': '$94.44',
							},
							{
								'Parking Unit Size': "40' Long",
								'Average Monthly Price': '$106.98',
							},
						],
					},
				},
			],
		},
		{
			title: 'Boat storage Preparation Checklist',
			background: 'gray',
			modules: [
				{
					title: 'Boat Storage Content',
					type: 'content',
					props: {
						title: 'How to Prepare Your Boat for Storage ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: boatStorageTips,
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'boat-storage-preparation-checklist',
						columnWidths: [1, 3],
						headers: [
							{
								label: 'step',
								key: 'step',
							},
							{
								label: 'description',
								key: 'description',
							},
						],
						rows: [
							{
								step: 'Step 1:Check the fluids',
								description:
									"Top off your gas tank, change the oil, and consider using a fuel stabilizer if you're putting the boat away for a longer period of time. If you're storing for more than six months, use a battery tender (also called a battery maintainer or charger) to make sure it runs when you're ready to take the boat out of storage.",
							},
							{
								step: 'Step 2: Fix any major repairs',
								description:
									'Take your boat into the shop and fix major repairs before you put it in storage.',
							},
							{
								step: 'Step 3: Use a cover',
								description:
									'The most important item required for boat storage is a cover specifically designed to fit your vessel. This ensures that there are no low areas to collect moisture, but leaves enough room for air to circulate, preventing mildew.',
							},
							{
								step: 'Step 4: Clean and remove excess',
								description:
									'Clean your boat, making sure to remove any organic material or water from the inside. These things can rot or mold and cause your boat to smell foul or even inflict significant damage.',
							},
							{
								step: 'Step 5: Take care of the engine',
								description:
									"Your boat's engine will be your main focus. Turn it on and make sure everything is moving smoothly, tightening up any parts that are loose or wobbly. Then disconnect the fuel line and let it run until it stops. Make sure the propeller shaft is well lubricated. When in doubt, go ahead and re-lubricate it to be safe.",
							},
							{
								step: 'Step 6: Flush the system',
								description:
									'The next step is to flush the engine (consult your owner’s manual to see which kit you need) as well as the cooling system. After you’re done, drain the engine of any water. Getting your boat ready for long-term storage may require additional professional assistance if you’re not sure how to tackle the mechanical steps yourself.',
							},
							{
								step: 'Step 7: Check the carburetor',
								description:
									'Turn the engine on again, and spray fogging oil (if you’re winterizing a fuel-injected engine, use two-cycle oil) into the carburetor. While the engine is still running, shut off the fuel supply using the fuel valve. When it stops, pull the spark plugs, use some fogging oil on the cylinders, crank the engine a few times, and reinstall the plugs.',
							},
							{
								step: 'Step 8: Prepare your boat trailer',
								description:
									"Check the tire pressure, tighten the lug nuts on the wheels, and test the wiring to make sure the lights are working. If you're storing the boat outside, buy an outboard motor lock to secure and protect this valuable piece. Cover the tires to prevent cracking from sun damage. Lastly, chock the wheels of the trailer and use a lock to secure the boat to a large, sturdy object.",
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Why Boat Storage Users Choose SpareFoot',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Boat Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'boat-related-content',
						contentCards: [
							{
								content:
									'How to Find The Right Storage Facility For Your Car, RV, or Boat',
								date: 'October 24, 2025',
								image: Featured1,
								link: 'https://sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat',
								title: 'General Storage Advice',
							},
							{
								content:
									'Boat Storage Tips: How to Store Your Boat Safely and Efficiently',
								date: 'September 24, 2025',
								image: Featured2,
								link: 'https://sparefoot.com/blog/storing-a-boat',
								title: 'How to Store It',
							},
							{
								content:
									'How to Winterize a Boat: Key Steps For Protecting Your Boat',
								date: 'September 3, 2024',
								image: Featured3,
								link: 'https://sparefoot.com/blog/how-to-winterize-a-boat',
								title: 'General Storage Advice',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'RV',
							'JetSki',
							'Kayak',
							'Car',
							'DriveUp',
							'24Hour',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
